const DAY_SECONDS = 24 * 60 * 60;

export function clampTimestamp(value: number, range: [number, number]): number {
  if (!Number.isFinite(value)) return range[0];
  return Math.min(range[1], Math.max(range[0], Math.round(value)));
}

export function startOfUtcDay(timestamp: number): number {
  const value = new Date(timestamp * 1000);
  return Date.UTC(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate()) / 1000;
}

export function utcDayRange(timestamp: number): [number, number] {
  const start = startOfUtcDay(timestamp);
  return [start, start + DAY_SECONDS - 300];
}

export function toUtcInputValue(timestamp: number): string {
  if (!Number.isFinite(timestamp)) return '';
  return new Date(timestamp * 1000).toISOString().slice(0, 19);
}

export function parseUtcInputValue(value: string): number | null {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?$/.test(value)) return null;
  const parsed = Date.parse(`${value.length === 16 ? `${value}:00` : value}Z`);
  return Number.isFinite(parsed) ? Math.round(parsed / 1000) : null;
}

export function formatUtc(timestamp: number, includeSeconds = false): string {
  if (!Number.isFinite(timestamp)) return 'Unavailable';
  const options: Intl.DateTimeFormatOptions = {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  };
  if (includeSeconds) options.second = '2-digit';
  return `${new Intl.DateTimeFormat('en-GB', options).format(new Date(timestamp * 1000))} UTC`;
}

export function apiTimestamp(timestamp: number): string {
  const date = new Date(timestamp * 1000);
  const two = (value: number) => value.toString().padStart(2, '0');
  return [
    date.getUTCFullYear(),
    two(date.getUTCMonth() + 1),
    two(date.getUTCDate()),
    `${two(date.getUTCHours())}:${two(date.getUTCMinutes())}:${two(date.getUTCSeconds())}`
  ].join('/');
}

export function parseEpoch(value: string | null, fallback: number): number {
  if (value == null || value.trim() === '') return fallback;
  const numeric = Number(value);
  return Number.isFinite(numeric) ? Math.round(numeric) : fallback;
}

export function normalizedRange(a: number, b: number, fallback: [number, number]): [number, number] {
  if (!Number.isFinite(a) || !Number.isFinite(b) || a >= b) return fallback;
  return [Math.round(a), Math.round(b)];
}

